import { illionGetters } from '@/store/modules/illion/routines'

export default {
  [illionGetters.IFRAME_URL]: state => state.iframeUrl,
  [illionGetters.BANK_STATEMENTS]: state => state.bankStatements
}
